var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showSection
    ? _c(
        "section",
        {
          staticClass:
            "analyses-lpu-cards-section d-flex flex-column ga-6 min-w-0 w-100",
          attrs: { "data-qa": "analyses_lpu_cards_section" },
        },
        [
          _c(
            "h2",
            {
              staticClass: "text-h6 text--text mb-0",
              class: { container: _setup.isMobile },
              attrs: {
                id: _setup.LPU_CARDS_SECTION_ANCHOR,
                "data-qa": "analyses_lpu_cards_title",
              },
            },
            [
              _vm._v(
                "\n    Где сдать анализы в " +
                  _vm._s(_setup.townNamePred) +
                  "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _setup.context.feature_flags.ff_analyses_filters
            ? _c(_setup.LpuCardsChips, {
                class: { container: _setup.isMobile },
                attrs: {
                  "applied-sort": _setup.appliedSort,
                  "applied-online-order": _setup.appliedOnlineOrder,
                  "applied-with-discount": _setup.appliedWithDiscount,
                  "applied-place": _setup.appliedPlace,
                  "apply-loading": _setup.isFiltersApplying,
                },
                on: {
                  apply: _setup.applyFilters,
                  "request-error": _setup.openRequestErrorDialog,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.showNotFound
            ? _c(_setup.LpuCardsNotFound, {
                class: { container: _setup.isMobile },
              })
            : [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column ga-4" },
                  [
                    _setup.showInitialExtras
                      ? [
                          _setup.ff_update_spec_design_lpus
                            ? [
                                _setup.specialPlacementLpuCards.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "analyses-lpu-cards-special-placement d-flex flex-column ga-2",
                                        attrs: {
                                          "data-qa":
                                            "analyses_lpu_cards_special_placement",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pl-4 text-caption text-warning--text text-no-wrap",
                                            attrs: {
                                              "data-qa":
                                                "analyses_lpu_cards_special_placement_label",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              Спецразмещение\n            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _setup.specialPlacementLpuCards,
                                          function (card) {
                                            return _c(_setup.AnalysesCard, {
                                              key: `placement-${card.id}`,
                                              attrs: { card: card },
                                            })
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  _setup.partnerExtraCards,
                                  function (card) {
                                    return _c(_setup.AnalysesCard, {
                                      key: `placement-${card.id}`,
                                      attrs: { card: card },
                                    })
                                  }
                                ),
                              ]
                            : _vm._l(
                                _setup.specialPlacementCards,
                                function (card) {
                                  return _c(_setup.AnalysesCard, {
                                    key: `placement-${card.id}`,
                                    attrs: { card: card },
                                  })
                                }
                              ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_setup.pageCards, function (card) {
                      return _c(_setup.AnalysesCard, {
                        key: card.id,
                        attrs: { card: card },
                      })
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _setup.showPagination
                  ? _c(_setup.LinkPagination, {
                      attrs: {
                        "data-qa": "analyses_lpu_cards_pagination",
                        "current-page": _setup.currentPage,
                        "page-range": _setup.pageRange,
                        "has-previous": _setup.hasPrevious,
                        "has-next": _setup.hasNext,
                        "previous-page-number": _setup.previousPageNumber,
                        "next-page-number": _setup.nextPageNumber,
                        "get-href": _setup.getPageHref,
                        "fetch-on-select": "",
                      },
                      on: { select: _setup.goToPage },
                    })
                  : _vm._e(),
              ],
          _vm._v(" "),
          _c(_setup.LpuCardsRequestErrorDialog, {
            attrs: { error: _setup.requestError },
            model: {
              value: _setup.isRequestErrorDialogOpen,
              callback: function ($$v) {
                _setup.isRequestErrorDialogOpen = $$v
              },
              expression: "isRequestErrorDialogOpen",
            },
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }